import { router } from 'expo-router';

import { Screen } from '@/src/components/Screen';
import { PostCreateComposer } from '@/src/features/posts/PostCreateComposer';

export default function ComposeScreen() {
  return (
    <Screen
      title="Create post"
      subtitle="Share a text update, photo, or video from one screen."
    >
      <PostCreateComposer
        onCancel={() => router.back()}
        onComplete={() => router.replace('/home')}
      />
    </Screen>
  );
}
